module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-04.453edee4.png";